var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb",attrs:{"aria-label":"Breadcrumb","role":"navigation"}},[_c('div',{staticClass:"breadcrumb-content"},[_vm._v("\n    当前位置：\n    "),_c('svg',{staticClass:"breadcrumb-svgicon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-home"}})]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-360a0587","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/breadcrumb/breadcrumb.vue
// module id = null
// module chunks = 